import { Link } from 'react-router-dom';
import Navigation from '../../components/feature/Navigation';
import SharedForm from '../../components/SharedForm';

const Admissions = () => {
  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <Navigation />

      {/* Hero Section */}
      <section className="py-20 bg-[#005A2C] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold mb-6">Admissions Information</h1>
          <p className="text-xl opacity-90 mb-8">
            Limited Places Available - Enrol Today
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:+263774872973"
              className="bg-[#007A3D] hover:bg-[#C6A44C] text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              Call: +263 774 872 973
            </a>
            <a
              href="tel:+263719872973"
              className="bg-[#C6A44C] hover:bg-[#007A3D] text-white px-8 py-4 rounded-lg font-semibold text-lg transition-colors whitespace-nowrap cursor-pointer"
            >
              Call: +263 719 872 973
            </a>
          </div>
        </div>
      </section>

      {/* Admissions Process */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-[#007A3D] mb-8 text-center">
            Admissions Process
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            <div className="text-center">
              <div className="w-16 h-16 bg-[#007A3D] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">1</span>
              </div>
              <h3 className="text-xl font-semibold text-[#007A3D] mb-3">
                Complete Application
              </h3>
              <p className="text-gray-600">
                Fill out the application form with student and parent information
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-[#C6A44C] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">2</span>
              </div>
              <h3 className="text-xl font-semibold text-[#007A3D] mb-3">
                Submit Documents
              </h3>
              <p className="text-gray-600">
                Provide required documents and pay admission fees
              </p>
            </div>

            <div className="text-center">
              <div className="w-16 h-16 bg-[#007A3D] rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-2xl font-bold text-white">3</span>
              </div>
              <h3 className="text-xl font-semibold text-[#007A3D] mb-3">
                Enrollment
              </h3>
              <p className="text-gray-600">
                Complete enrollment and prepare for the academic year
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Fee Structure */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-[#007A3D] mb-3 text-center">
            School Fees Structure
          </h2>
          <p className="text-center text-gray-500 mb-10 text-base max-w-2xl mx-auto">
            Fees differ by student type. Term 1 and Term 2 are longer terms (3.5 months each), while Term 3 follows the normal school calendar.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10">

            {/* Day School Card */}
            <div className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100">
              <div className="bg-[#007A3D] px-6 py-6 text-white text-center">
                <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-walk-line text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold">Day School</h3>
                <p className="text-white/75 text-sm mt-1">For students who commute daily</p>
              </div>
              <div className="p-6 space-y-3">
                <div className="flex items-center justify-between bg-gray-50 rounded-xl px-5 py-4">
                  <div>
                    <p className="font-semibold text-gray-700">Term 1</p>
                    <p className="text-xs text-gray-400">3.5 months</p>
                  </div>
                  <span className="text-2xl font-bold text-[#C6A44C]">USD 193</span>
                </div>
                <div className="flex items-center justify-between bg-gray-50 rounded-xl px-5 py-4">
                  <div>
                    <p className="font-semibold text-gray-700">Term 2</p>
                    <p className="text-xs text-gray-400">3.5 months</p>
                  </div>
                  <span className="text-2xl font-bold text-[#C6A44C]">USD 193</span>
                </div>
                <div className="flex items-center justify-between bg-[#007A3D]/5 rounded-xl px-5 py-4 border border-[#007A3D]/20">
                  <div>
                    <p className="font-semibold text-gray-700">Term 3</p>
                    <p className="text-xs text-gray-400">Normal calendar</p>
                  </div>
                  <span className="text-2xl font-bold text-[#007A3D]">USD 175</span>
                </div>
              </div>
            </div>

            {/* Boarding School Card */}
            <div className="bg-white rounded-2xl shadow-md overflow-hidden border border-gray-100">
              <div className="bg-[#C6A44C] px-6 py-6 text-white text-center">
                <div className="w-14 h-14 bg-white/20 rounded-full flex items-center justify-center mx-auto mb-3">
                  <i className="ri-home-4-line text-2xl"></i>
                </div>
                <h3 className="text-2xl font-bold">Boarding School</h3>
                <p className="text-white/75 text-sm mt-1">For full residential students</p>
              </div>
              <div className="p-6 space-y-3">
                <div className="flex items-center justify-between bg-gray-50 rounded-xl px-5 py-4">
                  <div>
                    <p className="font-semibold text-gray-700">Term 1</p>
                    <p className="text-xs text-gray-400">3.5 months</p>
                  </div>
                  <span className="text-2xl font-bold text-[#C6A44C]">USD 450</span>
                </div>
                <div className="flex items-center justify-between bg-gray-50 rounded-xl px-5 py-4">
                  <div>
                    <p className="font-semibold text-gray-700">Term 2</p>
                    <p className="text-xs text-gray-400">3.5 months</p>
                  </div>
                  <span className="text-2xl font-bold text-[#C6A44C]">USD 450</span>
                </div>
                <div className="flex items-center justify-between bg-[#C6A44C]/10 rounded-xl px-5 py-4 border border-[#C6A44C]/30">
                  <div>
                    <p className="font-semibold text-gray-700">Term 3</p>
                    <p className="text-xs text-gray-400">Normal calendar</p>
                  </div>
                  <span className="text-2xl font-bold text-[#B8954A]">USD 400</span>
                </div>
              </div>
            </div>
          </div>

          {/* Term Duration & Calendar */}
          <div className="bg-white p-8 rounded-2xl shadow-sm border-l-4 border-[#007A3D] mb-8">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 bg-[#007A3D]/10 rounded-xl flex items-center justify-center flex-shrink-0 mt-1">
                <i className="ri-calendar-check-line text-[#007A3D] text-lg"></i>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-[#007A3D] mb-2">
                  Term Duration &amp; School Calendar
                </h3>
                <p className="text-gray-700 leading-relaxed">
                  Term 1 and Term 2 each run for 3.5 months. During these terms, the school does not
                  close at the same time as other schools for holidays. Term 3 follows the normal school
                  calendar and closes at the same time as other schools.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-white p-6 rounded-2xl shadow-sm">
            <h3 className="text-xl font-semibold text-[#007A3D] mb-4">
              Initial Admission Requirements
            </h3>
            <ul className="space-y-2 text-gray-600">
              <li>• Admission fee (one-time payment for first enrollment)</li>
              <li>• Basic uniform requirements</li>
              <li>• USB 3-way flush 32GB (mandatory)</li>
              <li>• 3 Quire Notes Counterbooks (11 required)</li>
              <li>• 1 Quire Test &amp; Exercise Counterbooks (33 required)</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Boarding Requirements */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-[#007A3D] mb-8 text-center">
            Boarding Requirements Checklist
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-[#007A3D] mb-4">
                  Storage &amp; Uniform
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• Lockable Monarch/Trunk (1)</li>
                  <li>• School shirts/blouses (4)</li>
                  <li>• Trousers/skirts (4)</li>
                  <li>• Ties (2)</li>
                </ul>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-[#007A3D] mb-4">
                  Footwear
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• Black school shoes (2 pairs)</li>
                  <li>• White sports sneakers (1 pair)</li>
                  <li>• Slippers (1 pair)</li>
                </ul>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-[#007A3D] mb-4">
                  Bedding
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• Blankets (3)</li>
                  <li>• Bedsheets (2)</li>
                  <li>• Pillow (1)</li>
                </ul>
              </div>
            </div>

            <div className="space-y-6">
              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-[#007A3D] mb-4">
                  Personal Care
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• Full toiletries kit</li>
                  <li>• Sanitary wear</li>
                  <li>• Bathing soap</li>
                  <li>• Washing powder</li>
                </ul>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-[#007A3D] mb-4">
                  Academic Supplies
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• Satchel</li>
                  <li>• Graph book</li>
                  <li>• Ballpoints (10)</li>
                  <li>• Mathematical set</li>
                </ul>
              </div>

              <div className="bg-gray-50 p-6 rounded-lg">
                <h3 className="text-lg font-semibold text-[#007A3D] mb-4">
                  Utilities
                </h3>
                <ul className="space-y-2 text-gray-600">
                  <li>• Buckets (2)</li>
                  <li>• Rechargeable/solar torch</li>
                  <li>• Electric iron</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Additional Uniform Items */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-[#007A3D] mb-8 text-center">
            Additional Uniform Items
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-white p-6 rounded-lg shadow-sm text-center">
              <h3 className="text-lg font-semibold text-[#007A3D] mb-2">
                Hartel Blazer
              </h3>
              <div className="text-2xl font-bold text-[#C6A44C]">$45.00</div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm text-center">
              <h3 className="text-lg font-semibold text-[#007A3D] mb-2">
                Sports T-shirt
              </h3>
              <div className="text-2xl font-bold text-[#C6A44C]">$26.00</div>
              <p className="text-sm text-gray-600">(2 required)</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm text-center">
              <h3 className="text-lg font-semibold text-[#007A3D] mb-2">
                Tracksuit Complete
              </h3>
              <div className="text-2xl font-bold text-[#C6A44C]">$35.00</div>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-sm text-center">
              <h3 className="text-lg font-semibold text-[#007A3D] mb-2">
                Hartel Sun Hat
              </h3>
              <div className="text-2xl font-bold text-[#C6A44C]">$10.00</div>
            </div>
          </div>
        </div>
      </section>

      {/* Application Form (now uses the shared form component) */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-3xl font-bold text-[#007A3D] mb-8 text-center">Application Form</h2>
          {/* SharedForm builds the full message and sends it as the `message` parameter to EmailJS */}
          <SharedForm formType="admission" />
        </div>
      </section>

      {/* Contact Information */}
      <section className="py-16 bg-[#005A2C] text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl font-bold mb-8">Contact Information</h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
            <div>
              <h3 className="text-xl font-semibold mb-4">Phone Numbers</h3>
              <p className="mb-2">+263 774 872 973</p>
              <p>+263 719 872 973</p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-4">Email &amp; Address</h3>
              <p className="mb-2">info@elitecollege.co.zw</p>
              <p>535 Mataga</p>
            </div>
          </div>

          <p className="text-lg opacity-90">
            Payment plans available for uniforms. Contact us for detailed payment
            arrangements.
          </p>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#005A2C] text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center mb-4">
                <img
                  src="https://static.readdy.ai/image/e999ec2dea4e4b618de520757ef9db5d/995999b745e34f0ed4248820e32af9bb.jpeg"
                  alt="Elite College Logo"
                  className="h-10 w-10 object-cover rounded-full"
                />
                <h3
                  className="text-xl font-bold ml-3"
                  style={{ fontFamily: '"Pacifico", serif' }}
                >
                  Elite College
                </h3>
              </div>
              <p className="text-gray-300 mb-4">
                Empowering tomorrow's leaders through excellence in education
                and holistic development.
              </p>
              <div className="flex space-x-4">
                <button className="text-[#C6A44C] hover:text-white cursor-pointer">
                  <i className="ri-facebook-fill text-xl"></i>
                </button>
                <button className="text-[#C6A44C] hover:text-white cursor-pointer">
                  <i className="ri-twitter-fill text-xl"></i>
                </button>
                <button className="text-[#C6A44C] hover:text-white cursor-pointer">
                  <i className="ri-instagram-line text-xl"></i>
                </button>
                <button className="text-[#C6A44C] hover:text-white cursor-pointer">
                  <i className="ri-linkedin-fill text-xl"></i>
                </button>
                <a href="https://wa.me/263774872973" target="_blank" rel="noopener noreferrer" className="text-[#C6A44C] hover:text-white cursor-pointer">
                  <i className="ri-whatsapp-line text-xl"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/about"
                    className="text-gray-300 hover:text-[#C6A44C] cursor-pointer transition-colors"
                  >
                    About Us
                  </Link>
                </li>
                <li>
                  <Link
                    to="/admissions"
                    className="text-gray-300 hover:text-[#C6A44C] cursor-pointer transition-colors"
                  >
                    Admissions
                  </Link>
                </li>
                <li>
                  <Link
                    to="/gallery"
                    className="text-gray-300 hover:text-[#C6A44C] cursor-pointer transition-colors"
                  >
                    Gallery
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Contact Info</h4>
              <ul className="space-y-2 text-gray-300">
                <li className="flex items-center">
                  <i className="ri-map-pin-line mr-2 text-[#C6A44C]"></i>
                  535 Mataga
                </li>
                <li className="flex items-center">
                  <i className="ri-phone-line mr-2 text-[#C6A44C]"></i>
                  +263 774 872 973
                </li>
                <li className="flex items-center">
                  <i className="ri-mail-line mr-2 text-[#C6A44C]"></i>
                  info@elitecollege.co.zw
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-lg font-semibold mb-4">Office Hours</h4>
              <ul className="space-y-2 text-gray-300">
                <li>Monday - Friday: 8:00 AM - 6:00 PM</li>
                <li>Saturday: 9:00 AM - 4:00 PM</li>
                <li>Sunday: Closed</li>
              </ul>
            </div>
          </div>

          <div className="border-t border-[#007A3D] mt-8 pt-8 text-center text-gray-300">
            <p>&copy; 2026 Elite College. All rights reserved.</p>
            <p className="mt-2 text-sm">
              Powered by{' '}
              <a
                href="https://onhightech.co.zw"
                target="_blank"
                rel="noopener noreferrer"
                className="text-[#C6A44C] hover:text-white underline cursor-pointer transition-colors"
              >
                Onhightech Solutions
              </a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Admissions;
